<template>
  <div class="ended-chat">
    <div class="ended-chat-content">
      <p class="ended-chat-content-text">
        Chat has ended
      </p>
      <div class="rate-feedback-container">
        <span class="rate-feedback-title">
          Thank you for your feedback!
        </span>
        <MsgRate />
        <button
          class="rate-feedback-button"
          @click="isDetailedFeedbackModalOpen = true"
        >
          Share more feedback
        </button>
      </div>
      <MsgModal
        v-model="isDetailedFeedbackModalOpen"
        title="Share some details"
        :show-close-button="false"
      >
        <DetailedFeedbackModal
          @cancel="isDetailedFeedbackModalOpen = false"
          @submit="handleSubmitDetailedFeedback()"
        />
      </MsgModal>
      <MsgModal
        v-model="isThankForFeedbackModalOpen"
        title="Thank you for your feedback"
        size="medium"
      >
        <ThankForFeedbackModal
          @close="isThankForFeedbackModalOpen = false"
        />
      </MsgModal>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import MsgRate from "../../MsgUi/MsgRate.vue";
import MsgModal from "../../MsgUi/MsgModal.vue";
import DetailedFeedbackModal from "./DetailedFeedbackModal.vue";
import ThankForFeedbackModal from "./ThankForFeedbackModal.vue";
const isDetailedFeedbackModalOpen = ref(false);
const isThankForFeedbackModalOpen = ref(false);
function handleSubmitDetailedFeedback() {
  isDetailedFeedbackModalOpen.value = false;
  isThankForFeedbackModalOpen.value = true;
}
</script>

<style scoped>
.ended-chat{--color-blue-50:#f3f6fc;--color-blue-500:#1850c1;--color-grey-400:#adadad;--color-text-primary:#2d2d2d;--color-text-tertiary:#949494;--space-400:16px;--space-300:12px;--space-200:8px;--border-radius-md:8px;border-top:1px solid var(--color-grey-400)}.ended-chat-content-text{color:var(--color-text-tertiary);font-family:Inter;font-size:16px;margin:24px 0;text-align:center}.rate-feedback-container{align-items:center;background:var(--color-blue-50);border-radius:var(--border-radius-md);display:flex;flex-direction:column;gap:var(--space-300);justify-content:center;padding:var(--space-400) var(--space-200)}.rate-feedback-button{background:transparent;border:none;color:var(--color-blue-500);cursor:pointer;font-size:16px;font-weight:400;line-height:22px;padding:0}
</style>
